import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import './admin.css';

const AdminTours = () => {
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDetails, setShowDetails] = useState(null);
  const [filtroEstatus, setFiltroEstatus] = useState('todos');

  useEffect(() => {
    cargarTours();
  }, []);

  const cargarTours = async () => {
    try {
      setLoading(true);
      // Simulación - en producción usar API real
      const mockTours = [
        {
          id: 1,
          nombre: 'Juan Pérez García',
          email: 'juan@example.com',
          telefono: '555-123-4567',
          fecha_reserva: '2025-03-10',
          personas: 4,
          hora: '10:00',
          mensaje: 'Tour completo con catación',
          estatus: 'pendiente',
          incluye_catacion: true,
          incluye_recorrido: true,
          incluye_buffet: false,
          created_at: '2025-03-01T10:00:00Z'
        },
        {
          id: 2,
          nombre: 'María López',
          email: 'maria@example.com',
          telefono: '555-234-5678',
          fecha_reserva: '2025-03-12',
          personas: 2,
          hora: '11:30',
          mensaje: 'Solo catación',
          estatus: 'confirmado',
          incluye_catacion: true,
          incluye_recorrido: false,
          incluye_buffet: false,
          created_at: '2025-03-02T15:30:00Z'
        },
        {
          id: 3,
          nombre: 'Carlos Rodríguez',
          email: 'carlos@example.com',
          telefono: '555-345-6789',
          fecha_reserva: '2025-03-15',
          personas: 6,
          hora: '09:00',
          mensaje: 'Tour completo con buffet',
          estatus: 'confirmado',
          incluye_catacion: true,
          incluye_recorrido: true,
          incluye_buffet: true,
          created_at: '2025-03-03T09:15:00Z'
        },
        {
          id: 4,
          nombre: 'Ana Martínez',
          email: 'ana@example.com',
          telefono: '555-456-7890',
          fecha_reserva: '2025-03-08',
          personas: 3,
          hora: '12:00',
          mensaje: 'Recorrido solamente',
          estatus: 'completado',
          incluye_catacion: false,
          incluye_recorrido: true,
          incluye_buffet: false,
          created_at: '2025-02-28T14:20:00Z'
        },
        {
          id: 5,
          nombre: 'Roberto Sánchez',
          email: 'roberto@example.com',
          telefono: '555-567-8901',
          fecha_reserva: '2025-03-05',
          personas: 8,
          hora: '10:30',
          mensaje: 'Tour completo grupo',
          estatus: 'cancelado',
          incluye_catacion: true,
          incluye_recorrido: true,
          incluye_buffet: true,
          created_at: '2025-02-25T11:45:00Z'
        }
      ];
      setTours(mockTours);
    } catch (error) {
      console.error('Error cargando tours:', error);
    } finally {
      setLoading(false);
    }
  };

  const cambiarEstatus = async (id, nuevoEstatus) => {
    try {
      // Aquí iría la llamada a la API
      // await api.put(`/tours/${id}`, { estatus: nuevoEstatus });
      
      // Actualizar localmente
      setTours(tours.map(tour => 
        tour.id === id ? { ...tour, estatus: nuevoEstatus } : tour
      ));
      
      alert(`Tour ${id} actualizado a: ${nuevoEstatus}`);
    } catch (error) {
      console.error('Error actualizando tour:', error);
      alert('Error al actualizar el tour');
    }
  };

  const enviarConfirmacion = async (tour) => {
    try {
      // Aquí iría la llamada a la API de correos
      alert(`Correo de confirmación enviado a ${tour.email}`);
    } catch (error) {
      console.error('Error enviando correo:', error);
    }
  };

  const verDetalles = (id) => {
    setShowDetails(showDetails === id ? null : id);
  };

  const calcularCosto = (tour) => {
    let costo = 0;
    if (tour.incluye_catacion) costo += 200 * tour.personas;
    if (tour.incluye_recorrido) costo += 150 * tour.personas;
    if (tour.incluye_buffet && tour.personas >= 10) costo += 200 * tour.personas;
    return costo;
  };

  const toursFiltrados = filtroEstatus === 'todos' 
    ? tours 
    : tours.filter(t => t.estatus === filtroEstatus);

  const getBadgeClass = (estatus) => {
    const clases = {
      'pendiente': 'badge-warning',
      'confirmado': 'badge-success',
      'completado': 'badge-info',
      'cancelado': 'badge-danger'
    };
    return clases[estatus] || 'badge-secondary';
  };

  if (loading) return <div className="loading">Cargando tours...</div>;

  return (
    <div className="admin-tours">
      <div className="page-header">
        <div>
          <h1>🎫 Gestión de Tours</h1>
          <p>Administra las reservaciones de tours en la finca</p>
        </div>
        <button className="btn-primary" onClick={() => window.location.href='/tours'}>
          + Nuevo Tour
        </button>
      </div>

      {/* Filtros */}
      <div className="filtros-section">
        <div className="filtros-group">
          <button 
            className={`filtro-btn ${filtroEstatus === 'todos' ? 'active' : ''}`}
            onClick={() => setFiltroEstatus('todos')}
          >
            Todos
          </button>
          <button 
            className={`filtro-btn ${filtroEstatus === 'pendiente' ? 'active' : ''}`}
            onClick={() => setFiltroEstatus('pendiente')}
          >
            Pendientes
          </button>
          <button 
            className={`filtro-btn ${filtroEstatus === 'confirmado' ? 'active' : ''}`}
            onClick={() => setFiltroEstatus('confirmado')}
          >
            Confirmados
          </button>
          <button 
            className={`filtro-btn ${filtroEstatus === 'completado' ? 'active' : ''}`}
            onClick={() => setFiltroEstatus('completado')}
          >
            Completados
          </button>
          <button 
            className={`filtro-btn ${filtroEstatus === 'cancelado' ? 'active' : ''}`}
            onClick={() => setFiltroEstatus('cancelado')}
          >
            Cancelados
          </button>
        </div>
      </div>

      {/* Tabla de tours */}
      <div className="table-responsive">
        <table className="admin-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Cliente</th>
              <th>Email / Teléfono</th>
              <th>Fecha</th>
              <th>Hora</th>
              <th>Personas</th>
              <th>Incluye</th>
              <th>Costo</th>
              <th>Estatus</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {toursFiltrados.map(tour => (
              <React.Fragment key={tour.id}>
                <tr>
                  <td>#{tour.id}</td>
                  <td>
                    <strong>{tour.nombre}</strong>
                    {showDetails === tour.id && (
                      <div className="tour-mensaje">
                        📝 {tour.mensaje}
                      </div>
                    )}
                  </td>
                  <td>
                    <div>{tour.email}</div>
                    <small>{tour.telefono}</small>
                  </td>
                  <td>{new Date(tour.fecha_reserva).toLocaleDateString()}</td>
                  <td>{tour.hora}</td>
                  <td className="text-center">{tour.personas}</td>
                  <td>
                    <div className="tour-incluye">
                      {tour.incluye_catacion && <span className="badge badge-info">Catación</span>}
                      {tour.incluye_recorrido && <span className="badge badge-success">Recorrido</span>}
                      {tour.incluye_buffet && tour.personas >= 10 && (
                        <span className="badge badge-primary">Buffet</span>
                      )}
                    </div>
                  </td>
                  <td className="text-right">${calcularCosto(tour)}</td>
                  <td>
                    <select 
                      value={tour.estatus}
                      onChange={(e) => cambiarEstatus(tour.id, e.target.value)}
                      className={`status-select ${tour.estatus}`}
                    >
                      <option value="pendiente">Pendiente</option>
                      <option value="confirmado">Confirmado</option>
                      <option value="completado">Completado</option>
                      <option value="cancelado">Cancelado</option>
                    </select>
                  </td>
                  <td>
                    <div className="acciones-cell">
                      <button 
                        className="btn-icon" 
                        onClick={() => verDetalles(tour.id)}
                        title="Ver detalles"
                      >
                        👁️
                      </button>
                      <button 
                        className="btn-icon" 
                        onClick={() => enviarConfirmacion(tour)}
                        title="Enviar confirmación"
                      >
                        📧
                      </button>
                      <button 
                        className="btn-icon" 
                        onClick={() => window.open(`tel:${tour.telefono}`)}
                        title="Llamar"
                      >
                        📞
                      </button>
                      {tour.estatus === 'confirmado' && (
                        <button 
                          className="btn-icon" 
                          onClick={() => alert('Marcar como completado')}
                          title="Completar"
                        >
                          ✅
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminTours;